import React from "react";
import { useSession } from "../../authentications/SessionContext";

const TableLoader = ({ isLoading, children }) => {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  if (isLoading) {
    return (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <div className={`${isVTEX ? "loaderVtex" : "loader"}`} />
      </div>
    );
  }
  return <>{children}</>;
};

export default TableLoader;
